import React from "react";
import { motion } from "framer-motion";

const PromotionalBanner = () => {
    return (
        <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="sticky top-0 z-[100] bg-[#FFF9E6] border border-primary p-4 flex items-center gap-3"
        >
            <div className="max-w-7xl mx-auto flex items-center justify-center text-center gap-3 ">
                <p className="text-sm md:text-base font-base tracking-wide">
                    🎉 Get 50 free credits when you sign up today. Start translating instantly — no card needed.
                </p>

            </div>
        </motion.div>
    );
};

export default PromotionalBanner;
